import { cardPreferenceCenterPath, depositPath, paymentPath } from 'Modules/cardPayment/routes';
import { createFinancingPath } from 'Modules/financing/routes';
import { createFinancingPath as patientfiPath } from 'Modules/patientfi/routes';
import { createFinancingPath as fortivaPath } from 'Modules/fortiva/routes';
import { lendFlowHomePath } from 'Modules/lendFlow/routes';

export const platformPaths = {
  DEPOSIT: depositPath,
  ADD_CARD: cardPreferenceCenterPath,
  PAYMENT: paymentPath,
  FINANCING: createFinancingPath,
  FINANCING_PATIENTFI: patientfiPath,
  FINANCING_FORTIVA: fortivaPath,
  FINANCING_LENDFLOW: lendFlowHomePath,
};
